export const LOAD_ORGANISATION_LIST = 'organisation/LOAD_ORGANISATION_LIST';
export const LOAD_ORGANISATION_LIST_SUCCESS =
  'organisation/LOAD_ORGANISATION_LIST_SUCCESS';
export const LOAD_ORGANISATION_LIST_ERROR =
  'organisation/LOAD_ORGANISATION_LIST_ERROR';

//Load organisation detail
export const LOAD_ORGANISATION_DETAIL = 'organisation/LOAD_ORGANISATION_DETAIL';
export const LOAD_ORGANISATION_DETAIL_SUCCESS =
  'organisation/LOAD_ORGANISATION_DETAIL_SUCCESS';
export const LOAD_ORGANISATION_DETAIL_ERROR =
  'organisation/LOAD_ORGANISATION_DETAIL_ERROR';

//Load organisation site detail
export const LOAD_COMPANY_SITE_DETAIL = 'organisation/LOAD_COMPANY_SITE_DETAIL';
export const LOAD_COMPANY_SITE_DETAIL_SUCCESS =
  'organisation/LOAD_COMPANY_SITE_DETAIL_SUCCESS';
export const LOAD_COMPANY_SITE_DETAIL_ERROR =
  'organisation/LOAD_COMPANY_SITE_DETAIL_ERROR';

//Load company site list
export const LOAD_COMPANY_SITE_LIST = 'organisation/LOAD_COMPANY_SITE_LIST';
export const LOAD_COMPANY_SITE_LIST_SUCCESS =
  'organisation/LOAD_COMPANY_SITE_LIST_SUCCESS';
export const LOAD_COMPANY_SITE_LIST_ERROR =
  'organisation/LOAD_ORGANISATION_LIST_ERROR';
